export default __webpack_public_path__ + "static/media/thumbnail.15a3ecd3.png";